// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.note.NoteResponse */
/* istanbul ignore next */
@GandalfModel
export class NoteResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	createdBy!: string | null;

	@GandalfProperty({ designType: Date })
	createdOn!: Date | null;

	@GandalfProperty({ designType: String })
	currentUser!: string | null;

	@GandalfProperty({ designType: Boolean })
	editable!: boolean | null;

	@GandalfConstantDecorator(constants.EntityType)
	@GandalfProperty({ designType: constants.EntityType })
	entityType!: constants.EntityType | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: Number })
	parentId!: number | null;

	@GandalfConstantDecorator(constants.NoteStatus)
	@GandalfProperty({ designType: constants.NoteStatus })
	status!: constants.NoteStatus | null;

	@GandalfProperty({ designType: String })
	text!: string | null;

	@GandalfProperty({ designType: Number })
	version!: number | null;

}
